import { useState } from 'react';
import { DEFAULT_STATUS_MODAL } from '~/modules/covenants/constants.tsx';

export const useStatusModal = () => {
  const [statusModal, setStatusModal] = useState(DEFAULT_STATUS_MODAL);

  const closeStatusModal = () => setStatusModal((prev) => ({ ...prev, open: false }));

  return { statusModal, setStatusModal, closeStatusModal };
};
